import {
    Avatar,
    AvatarGroup,
    Box,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    Paper,
    TextField,
    Typography,
    useTheme,
    useMediaQuery,
    Container,
    Grid,
} from '@mui/material'
import React, { useEffect, useState, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import styles from './SignUp.module.css'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import logo from '../../Assets/Images/BuildLinkCompleteLogo.png'
import buildBid from '../../Assets/Images/Build-BID2.png'
import buildVid from '../../Assets/Images/buildvids-logo.png'
import buildLink from '../../Assets/Images/BuildLinkCompleteLogo.png'
import linksurance from '../../Assets/Images/linksurance-logo.png'
import buildStudio from '../../Assets/Images/BuildStudiologo-gold.png'
import banner_right from '../../Assets/Images/banner_right.png'
import grid from '../../Assets/Images/Group194.png'
import constructionImg from '../../Assets/Images/Group213.png'
import { useForm } from 'react-hook-form'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined'
import EastRight from '@mui/icons-material/East'

import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined'
import {
    AlertCmp,
    BackDropCmp,
    DropDownCmp,
    InputCmp,
    InputCmpWithEmailValidation,
    SelectCmp,
} from '../../Components'
import { yupResolver } from '@hookform/resolvers/yup'
import { validation } from '../../Config'
import { useDispatch, useSelector } from 'react-redux'
import { SignUpAction } from '../../Store/Actions/AuthActions'

export default function SignUp() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const isTablet = useMediaQuery(theme.breakpoints.down('md'))
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))

    const [open, setOpen] = useState(false)
    const [alertStatus, setAlertStatus] = useState('')
    const [emailValidation, setEmailValidation] = useState({ isValid: null, message: '', isLoading: false })

    const {
        handleSubmit,
        control,
        formState: { errors },
        watch,
    } = useForm({
        defaultValues: {
            firstName: '',
            lastName: '',
            email: '',
            userType: '',
            password: '',
            confirmPassword: '',
            acceptPolicy: false,
        },
        resolver: yupResolver(validation.signupValidation),
    })

    const watchedEmail = watch('email');

    const handleEmailValidationChange = (validationResult) => {
        setEmailValidation(validationResult);
    };

    const sigupHandler = (signupData) => {
        // Check if email validation is still loading
        if (emailValidation.isLoading) {
            setAlertStatus('Please wait for email validation to complete');
            setOpen(true);
            return;
        }

        // Check if email validation failed
        if (emailValidation.isValid === false) {
            setAlertStatus(emailValidation.message || 'Please enter a valid email address');
            setOpen(true);
            return;
        }

        // Basic email format validation as fallback
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(signupData.email)) {
            setAlertStatus('Please enter a valid email address');
            setOpen(true);
            return;
        }

        dispatch(SignUpAction(signupData, navigate))
    }

    const {
        userSignupLoading,
        userSignupdata,
        userSignupMessage,
        userSignupError,
    } = useSelector((state) => state.SignupReducers)

    useEffect(() => {
        if (userSignupError) {
            setAlertStatus(userSignupError)
            setOpen(true)
        }
    }, [userSignupError])

    useEffect(() => {
        if (userSignupMessage) {
            setAlertStatus(userSignupMessage)
            setOpen(true)
            navigate('/profilecompletion')
        }
    }, [userSignupMessage])

    return (
        <Box
            sx={{
                display: 'flex',
                minHeight: '100vh',
                backgroundColor: '#EFF5FD',
                flexDirection: { xs: 'column', lg: 'row' }
            }}
        >
            <AlertCmp
                setOpen={setOpen}
                text={alertStatus}
                error={userSignupError}
                open={open}
            />

            {/* Main Content Area */}
            <Box
                component={Paper}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: 'none',
                    height: { xs: 'auto', lg: '100vh' },
                    justifyContent: 'center',
                    width: { xs: '100%', lg: '60%' },
                    alignItems: { xs: 'center', lg: 'flex-start' },
                    padding: {
                        xs: '2rem 1rem',
                        sm: '3rem 2rem',
                        md: '4rem 3rem',
                        lg: '6.4rem'
                    },
                    backgroundColor: '#EFF5FD',
                    minHeight: { xs: '100vh', lg: 'auto' }
                }}
            >
                <Box
                    sx={{
                        width: { xs: '100%', sm: '100%' },
                        maxWidth: '100%',
                        margin: { xs: '0 auto', lg: '0' },
                        backgroundColor: {xs: 'white', md: 'transparent'},
                        padding: {xs: '2rem 1rem',  md: '0'},
                        borderRadius: {xs: '20px'},
                    }}
                >
                    <Typography
                        variant="h3"
                        sx={{
                            marginTop: { xs: 2, lg: 4 },
                            letterSpacing: '-0.025em',
                            lineHeight: 1.25,
                            fontWeight: 800,
                            fontSize: { xs: '1.75rem', sm: '2rem', lg: '2.2rem' },
                            textAlign: { xs: 'center', lg: 'left' }
                        }}
                        gutterBottom
                    >
                        Sign up
                    </Typography>
                    <Typography
                        variant="subtitle2"
                        sx={{
                            textAlign: { xs: 'center', lg: 'left' },
                            marginBottom: 3
                        }}
                    >
                        Let's get you all set up so you can access your personal
                        account.
                    </Typography>

                    <form
                        name="loginForm"
                        onSubmit={handleSubmit(sigupHandler)}
                        style={{ width: '100%' }}
                    >
                        {/* Name Fields */}
                        <Box
                            sx={{
                                display: 'flex',
                                gap: 2,
                                width: '100%',
                                flexDirection: { xs: 'column', sm: 'row' },
                                marginBottom: 3
                            }}
                        >
                            <Box sx={{ flex: 1 }}>
                                <InputCmp
                                    label="First Name"
                                    autoFocus
                                    name="firstName"
                                    control={control}
                                    className={styles.auth_form_field}
                                    startIcon={<PersonOutlineOutlinedIcon />}
                                />
                            </Box>
                            <Box sx={{ flex: 1 }}>
                                <InputCmp
                                    name="lastName"
                                    control={control}
                                    label="Last Name"
                                    variant="outlined"
                                    className={styles.auth_form_field}
                                    startIcon={<PersonOutlineOutlinedIcon />}
                                />
                            </Box>
                        </Box>

                        {/* Email and User Type Fields */}
                        <Box
                            sx={{
                                display: 'flex',
                                gap: 2,
                                width: '100%',
                                flexDirection: { xs: 'column', sm: 'row' },
                                marginBottom: 3
                            }}
                        >
                            <Box sx={{ flex: 1 }}>
                                <InputCmpWithEmailValidation
                                    name="email"
                                    control={control}
                                    label="Your Email"
                                    type="email"
                                    variant="outlined"
                                    className={styles.auth_form_field}
                                    startIcon={<MailOutlineIcon />}
                                    enableEmailValidation={true}
                                    validationDelay={100}
                                    onValidationChange={handleEmailValidationChange}
                                />
                            </Box>
                            <Box sx={{ flex: 1 }}>
                                <SelectCmp
                                    name="userType"
                                    control={control}
                                    label="User Type"
                                    options={[
                                        'Pro',
                                        'Manufacturer',
                                        'Linksurance Agent',
                                        'Supplier',
                                        'Home Owner / Client',
                                    ]}
                                    disableClearable
                                    className={styles.auth_form_select_field}
                                    startIcon={<BadgeOutlinedIcon />}
                                />
                            </Box>
                        </Box>

                        {/* Password Fields */}
                        <Box
                            sx={{
                                display: 'flex',
                                gap: 2,
                                width: '100%',
                                flexDirection: { xs: 'column', sm: 'row' },
                                marginBottom: 3
                            }}
                        >
                            <Box sx={{ flex: 1 }}>
                                <InputCmp
                                    name="password"
                                    control={control}
                                    label="Password"
                                    type="password"
                                    className={styles.auth_form_field}
                                    startIcon={<LockOutlinedIcon />}
                                />
                            </Box>
                            <Box sx={{ flex: 1 }}>
                                <InputCmp
                                    name="confirmPassword"
                                    control={control}
                                    label="Re-Password"
                                    type="password"
                                    className={styles.auth_form_field}
                                    startIcon={<LockOutlinedIcon />}
                                />
                            </Box>
                        </Box>

                        {/* Accept Policy Checkbox */}
                        <FormControl
                            required
                            error={!!errors.acceptPolicy}
                            sx={{ width: '100%', marginBottom: 3 }}
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        {...control.register('acceptPolicy')}
                                        color="primary"
                                    />
                                }
                                label={
                                    <span style={{ fontSize: { xs: '16px', sm: '18px' } }}>
                                        I Accept Privacy Policy | Terms and
                                        Condition
                                    </span>
                                }
                            />
                            {errors.acceptPolicy && (
                                <Typography color="error" variant="caption">
                                    {errors.acceptPolicy.message}
                                </Typography>
                            )}
                        </FormControl>

                        {/* Submit Button and Login Link */}
                        <Box
                            sx={{
                                display: 'flex',
                                gap: 2,
                                width: '100%',
                                alignItems: 'center',
                                flexDirection: { xs: 'column', lg: 'row' },
                                marginBottom: 3
                            }}
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                sx={{
                                    width: { xs: '100%', lg: '50%' },
                                    marginTop: 2,
                                    borderRadius: '28px',
                                    backgroundColor: '#005699',
                                    height: '48px',
                                    fontSize: '1rem',
                                    fontWeight: 600,
                                    '&:hover': {
                                        backgroundColor: '#004080'
                                    }
                                }}
                                aria-label="Sign up"
                                size="large"
                                type="submit"
                                disabled={userSignupLoading || emailValidation.isLoading || emailValidation.isValid === false}
                            >
                                {userSignupLoading ? 'Signing Up...' : 'Sign UP'}
                            </Button>
                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: 2,
                                    alignItems: 'center',
                                    flexDirection: { xs: 'column', sm: 'row' }
                                }}
                            >
                                <span style={{ fontSize: { xs: '16px', sm: '18px' } }}>- or -</span>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        flexDirection: { xs: 'row', }
                                    }}
                                >
                                    <Typography style={{ fontSize: { xs: '16px', sm: '18px' } }}>
                                        Already have an account?
                                    </Typography>
                                    <Link
                                        to="/login"
                                        style={{
                                            color: 'var(--primary-color)',
                                            textDecoration: 'underline',
                                            fontWeight: 600,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.5rem'
                                        }}
                                    >
                                        <EastRight
                                            style={{
                                                color: 'black',
                                                fontSize: '20px'
                                            }}
                                        />
                                        Login
                                    </Link>
                                </Box>
                            </Box>
                        </Box>
                    </form>
                </Box>

                {/* Social Media Logos - Hidden on mobile */}
                <Box
                    sx={{
                        display: { xs: 'none', md: 'flex' },
                        alignItems: 'center',
                        marginTop: 4,
                        justifyContent: 'space-around',
                        gap: 2,
                        width: '100%',
                        maxWidth: '100%'
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: 'white',
                            padding: '0.5rem 1rem',
                            borderRadius: '20px',
                            height: '80px',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <img
                            src={buildLink}
                            alt="logo"
                            style={{ width: '7rem' }}
                        />
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: 'white',
                            padding: '0.5rem 1rem',
                            borderRadius: '20px',
                            height: '80px',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <img
                            src={buildStudio}
                            alt="logo"
                            style={{ width: '7rem' }}
                        />
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: 'white',
                            padding: '0.5rem 1rem',
                            borderRadius: '20px',
                            height: '80px',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <img
                            src={buildBid}
                            alt="logo"
                            style={{ width: '7rem' }}
                        />
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: 'white',
                            padding: '0.5rem 1rem',
                            borderRadius: '20px',
                            height: '80px',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <img
                            src={linksurance}
                            alt="logo"
                            style={{ width: '7rem' }}
                        />
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: 'white',
                            padding: '0.5rem 1rem',
                            borderRadius: '20px',
                            height: '80px',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <img
                            src={buildVid}
                            alt="logo"
                            style={{ width: '7rem' }}
                        />
                    </Box>
                </Box>
            </Box>

            {/* Right Side Banner - Hidden on mobile and tablet */}
            <Box
                sx={{
                    display: { xs: 'none', lg: 'block' },
                    position: 'relative',
                    flex: 1,
                    height: '100vh',
                    backgroundColor: '#EFF5FD',
                    overflow: 'hidden'
                }}
            >
                <Box
                    sx={{
                        backgroundColor: '#cce3fc',
                        height: '80vh',
                        width: '420px',
                        position: 'absolute',
                        top: 0,
                        right: '70px',
                        borderBottomRightRadius: '220px',
                        borderBottomLeftRadius: '220px',
                        overflow: 'hidden',
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            position: 'absolute',
                            top: '80px',
                            left: 0,
                            right: 0
                        }}
                    >
                        <img
                            src={buildLink}
                            alt="logo"
                            style={{ width: '250px' }}
                        />
                    </Box>

                    <Box
                        sx={{
                            position: 'relative',
                            textAlign: 'center',
                            marginBottom: '15px',
                            width: '100%',
                            '&::before': {
                                content: '"\\201C"',
                                position: 'absolute',
                                top: '-55px',
                                left: '25px',
                                color: '#b3c5dc',
                                fontSize: '70px',
                                fontWeight: 800
                            },
                            '&::after': {
                                content: '"\\201D"',
                                position: 'absolute',
                                bottom: '-75px',
                                right: '30px',
                                color: '#b3c5dc',
                                fontSize: '70px',
                                fontWeight: 800
                            }
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 900,
                                fontSize: '33px'
                            }}
                        >
                            Construction Business <br /> Networking Platform
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            fontSize: '1.6rem',
                            textWrap: 'nowrap',
                            textAlign: 'center',
                            borderTop: '3px solid black',
                            borderBottom: '3px solid black',
                            position: 'absolute',
                            bottom: '140px',
                            left: 0,
                            right: 0,
                            paddingTop: '7px',
                            paddingBottom: '7px',
                            letterSpacing: '1px',
                            fontFamily: 'Arial, Helvetica, sans-serif'
                        }}
                    >
                        "Trust the Pros the Pros trust"
                    </Box>
                </Box>

                <Box
                    sx={{
                        position: 'absolute',
                        bottom: '70px',
                        right: '70px',
                        textAlign: 'end',
                        fontWeight: 'lighter',
                        display: 'flex',
                        flexDirection: 'column',
                        width: '150%'
                    }}
                >
                    <Typography variant="subtitle2">
                        <a
                            href="https://staging.buildlink.com/privacy-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: 'inherit', textDecoration: 'none' }}
                        >
                            Privacy Policy
                        </a>
                        {' | '}
                        <a
                            href="https://staging.buildlink.com/terms-of-service"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: 'inherit', textDecoration: 'none' }}
                        >
                            Terms of Services
                        </a>
                        {' | '}
                        <a
                            href="https://staging.buildlink.com/disclaimer"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: 'inherit', textDecoration: 'none' }}
                        >
                            Disclaimer
                        </a>
                        {' | '}
                        <a
                            href="https://staging.buildlink.com/copyright-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: 'inherit', textDecoration: 'none' }}
                        >
                            Copyright Policy
                        </a>
                    </Typography>
                    <Typography variant="subtitle2">
                        © {new Date().getFullYear()} Buildlink.com
                    </Typography>
                </Box>
            </Box>
            <BackDropCmp setOpen={userSignupLoading} />
        </Box>
    )
}
